import React from "react";
import MultiSelectCheckbox from "./MultiSelectCheckbox";

const StoreSelectorDropdown = ({ storeOptions, selectedStore, setSelectedStore }) => (
  <div className="dropdown-container">
    <MultiSelectCheckbox
      options={storeOptions}
      selectedOptions={selectedStore}
      setSelectedOptions={setSelectedStore}
    />
  </div>
);

export default StoreSelectorDropdown;